import { FCreneaux } from './FCreneaux';

export class FRdv {
    
    idRdv:number;
    nom: string;
    prenom: string;
    immatriculation: string;
    telephone: string;
    email: string;
    dateCreneau:string;

    fcreneaux: FCreneaux;

    constructor(idRdv:number, nom:string, prenom:string, immatriculation:string, telephone:string, email:string, fcreneau:FCreneaux  ){
      this.idRdv = idRdv;
      this.nom = nom;
      this.prenom = prenom;
      this.immatriculation = immatriculation;
      this.telephone = telephone;
      this.email = email;
 

      if(fcreneau != null && fcreneau != null){
        this.fcreneaux= new FCreneaux(fcreneau.idCreneau, fcreneau.dateCreneau, fcreneau.libre, fcreneau.idSite, fcreneau.bloque);
    }

   }

   public static fromJson(json: Object): FRdv {
        
    return new FRdv(
        json['idRdv'],
        json['nom'],
        json['prenom'],
        json['immatriculation'],
        json['telephone'], 
        json['email'],
        json['fcreneaux']
        )
}
  }